"use client";

import { BlacksmithLogomarkAnimationSVG } from "@/components/BlacksmithLogoSVG";
import { DesktopDragRegion } from "@/components/desktop/DesktopLayoutSkeleton";

// DashboardRouterProvider reads useSearchParams, which bails the prerender out
// to the client, so this is the HTML shown until hydration. It mirrors the
// server branch of AuthProvider's initial-load state; the sidebar skeleton
// needs the router and localStorage, so it can only render after hydration.
export function DashboardShellFallback() {
  return (
    <div className="flex h-screen items-center justify-center">
      <DesktopDragRegion />
      <div className="w-32 h-32">
        <BlacksmithLogomarkAnimationSVG />
      </div>
    </div>
  );
}
